export const TEAMS = [
  {
    abbr: 'NJD',
    teamId: 1,
    nickname: 'Devils',
    teamName: 'New Jersey Devils',
    teamNameFr: 'Devils de New Jersey',
    teamDivision: 'Metropolitan',
  },
  {
    abbr: 'NYI',
    teamId: 2,
    nickname: 'Islanders',
    teamName: 'New York Islanders',
    teamNameFr: 'Islanders de New York',
    teamDivision: 'Metropolitan',
  },
  {
    abbr: 'NYR',
    teamId: 3,
    nickname: 'Rangers',
    teamName: 'New York Rangers',
    teamNameFr: 'Rangers de New York',
    teamDivision: 'Metropolitan',
  },
  {
    abbr: 'PHI',
    teamId: 4,
    nickname: 'Flyers',
    teamName: 'Philadelphia Flyers',
    teamNameFr: 'Flyers de Philadelphia',
    teamDivision: 'Metropolitan',
  },
  {
    abbr: 'PIT',
    teamId: 5,
    nickname: 'Penguins',
    teamName: 'Pittsburgh Penguins',
    teamNameFr: 'Penguins de Pittsburgh',
    teamDivision: 'Metropolitan',
  },
  {
    abbr: 'BOS',
    teamId: 6,
    nickname: 'Bruins',
    teamName: 'Boston Bruins',
    teamNameFr: 'Bruins de Boston',
    teamDivision: 'Atlantic',
  },
  {
    abbr: 'BUF',
    teamId: 7,
    nickname: 'Sabres',
    teamName: 'Buffalo Sabres',
    teamNameFr: 'Sabres de Buffalo',
    teamDivision: 'Atlantic',
  },
  {
    abbr: 'MTL',
    teamId: 8,
    nickname: 'Canadiens',
    teamName: 'Montreal Canadiens',
    teamNameFr: 'Canadiens de Montreal',
    teamDivision: 'Atlantic',
  },
  {
    abbr: 'OTT',
    teamId: 9,
    nickname: 'Senators',
    teamName: 'Ottawa Senators',
    teamNameFr: 'Senators de Ottawa',
    teamDivision: 'Atlantic',
  },
  {
    abbr: 'TOR',
    teamId: 10,
    nickname: 'Maple Leafs',
    teamName: 'Toronto Maple Leafs',
    teamNameFr: 'Maple Leafs de Toronto',
    teamDivision: 'Atlantic',
  },
  {
    abbr: 'CAR',
    teamId: 12,
    nickname: 'Hurricanes',
    teamName: 'Carolina Hurricanes',
    teamNameFr: 'Hurricanes de Carolina',
    teamDivision: 'Metropolitan',
  },
  {
    abbr: 'FLA',
    teamId: 13,
    nickname: 'Panthers',
    teamName: 'Florida Panthers',
    teamNameFr: 'Panthers de Florida',
    teamDivision: 'Atlantic',
  },
  {
    abbr: 'TBL',
    teamId: 14,
    nickname: 'Bay Lightning',
    teamName: 'Tampa Bay Lightning',
    teamNameFr: 'Lightning de Tampa Bay',
    teamDivision: 'Atlantic',
  },
  {
    abbr: 'WSH',
    teamId: 15,
    nickname: 'Capitals',
    teamName: 'Washington Capitals',
    teamNameFr: 'Capitals de Washington',
    teamDivision: 'Metropolitan',
  },
  {
    abbr: 'WPG',
    teamId: 52,
    nickname: 'Jets',
    teamName: 'Winnipeg Jets',
    teamNameFr: 'Jets de Winnipeg',
    teamDivision: 'Central',
  },
  {
    abbr: 'CHI',
    teamId: 16,
    nickname: 'Blackhawks',
    teamName: 'Chicago Blackhawks',
    teamNameFr: 'Blackhawks de Chicago',
    teamDivision: 'Central',
  },
  {
    abbr: 'DET',
    teamId: 17,
    nickname: 'Red Wings',
    teamName: 'Detroit Red Wings',
    teamNameFr: 'Red Wings de Detroit',
    teamDivision: 'Atlantic',
  },
  {
    abbr: 'NSH',
    teamId: 18,
    nickname: 'Predators',
    teamName: 'Nashville Predators',
    teamNameFr: 'Predators de Nashville',
    teamDivision: 'Central',
  },
  {
    abbr: 'STL',
    teamId: 19,
    nickname: 'Blues',
    teamName: 'St. Louis Blues',
    teamNameFr: 'Blues de St. Louis',
    teamDivision: 'Central',
  },
  {
    abbr: 'CGY',
    teamId: 20,
    nickname: 'Flames',
    teamName: 'Calgary Flames',
    teamNameFr: 'Flames de Calgary',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'COL',
    teamId: 21,
    nickname: 'Avalanche',
    teamName: 'Colorado Avalanche',
    teamNameFr: 'Avalanche de Colorado',
    teamDivision: 'Central',
  },
  {
    abbr: 'EDM',
    teamId: 22,
    nickname: 'Oilers',
    teamName: 'Edmonton Oilers',
    teamNameFr: 'Oilers de Edmonton',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'VAN',
    teamId: 23,
    nickname: 'Canucks',
    teamName: 'Vancouver Canucks',
    teamNameFr: 'Canucks de Vancouver',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'ANA',
    teamId: 24,
    nickname: 'Ducks',
    teamName: 'Anaheim Ducks',
    teamNameFr: 'Ducks de Anaheim',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'DAL',
    teamId: 25,
    nickname: 'Stars',
    teamName: 'Dallas Stars',
    teamNameFr: 'Stars de Dallas',
    teamDivision: 'Central',
  },
  {
    abbr: 'LAK',
    teamId: 26,
    nickname: 'Kings',
    teamName: 'Los Angeles Kings',
    teamNameFr: 'Kings de Los Angeles',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'ARI',
    teamId: 53,
    nickname: 'Coyotes',
    teamName: 'Arizona Coyotes',
    teamNameFr: 'Coyotes de Arizona',
    teamDivision: 'Central',
  },
  {
    abbr: 'SJS',
    teamId: 28,
    nickname: 'Sharks',
    teamName: 'San Jose Sharks',
    teamNameFr: 'Sharks de San Jose',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'CBJ',
    teamId: 29,
    nickname: 'Blue Jackets',
    teamName: 'Columbus Blue Jackets',
    teamNameFr: 'Blue Jackets de Columbus',
    teamDivision: 'Metropolitan',
  },
  {
    abbr: 'MIN',
    teamId: 30,
    nickname: 'Wild',
    teamName: 'Minnesota Wild',
    teamNameFr: 'Wild de Minnesota',
    teamDivision: 'Central',
  },
  {
    abbr: 'VGK',
    teamId: 54,
    nickname: 'Golden Knights',
    teamName: 'Vegas Golden Knights',
    teamNameFr: 'Golden Knights de Vegas',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'SEA',
    teamId: 55,
    nickname: 'Kraken',
    teamName: 'Seattle Kraken',
    teamNameFr: 'Kraken de Seattle',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'UTA',
    teamId: 59,
    nickname: 'Utah',
    teamName: 'Utah Hockey Club',
    teamNameFr: '',
    teamDivision: 'Pacific',
  },
  {
    abbr: 'NOTEAM',
    teamId: 100,
    nickname: 'favourite',
    teamName: 'No favourite team',
    teamNameFr: 'No favourite team',
    teamDivision: 'Pacific',
  },
];
